/**
 * Scroll to the section where is the element in the given ID
 * @param {string} id Is the ID of the element
 */
export function scrollToElement(id) {
    try {
        let elem = document.getElementById(id);
        let ypos = getOffset(elem).top;

        window.scrollTo({
            top: ypos,
            behavior: 'smooth',
        });
    } catch (error) {
        console.log(error)
    }
}

export function scrollToBottom() {
    try {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
        });
    } catch (error) {
        
    }
}

function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
}